import { theme } from '@theme';
import styled from 'styled-components';

export const BPS = styled.span.attrs({
  className: 'bps',
})<{ isActive: boolean }>`
  background: ${theme.palette.lightPurpleTwo};
  border-radius: 4px;
  text-align: center;
  position: absolute;
  top: 10px;
  right: 10px;
  padding: 5px;
  min-width: 44px;

  em {
    font-size: ${theme.typography.fontSize}px;
    color: ${theme.palette.darkPurpleTwo};
    line-height: 16px;
    display: block;
    font-style: ${theme.typography.normalFontStyle};
  }
  b {
    font-size: ${theme.typography.fontSize20}px;
    color: ${theme.palette.darkPurpleThree};
    line-height: 1;
    span {
      color: ${theme.palette.dusty};
      vertical-align: top;
      font-size: 80%;
    }
  }

  ${(props) =>
    props.isActive
      ? ''
      : `
        background: ${theme.palette.basicGrayTwo};

        em {
          color: ${theme.palette.silver};
        }

        b {
          color: ${theme.palette.silver};
          font-weight: ${theme.typography.fontWeights.light};
          font-size: 120%;
        }
      `}
`;

export const FootNote = styled.p`
  color: ${theme.palette.dusty};
  font-size: ${theme.typography.h6}px;
  font-weight: ${theme.typography.fontWeights.medium};
  position: relative;
  padding-left: 20px;
`;

export const RecallSticker = styled.span`
  position: absolute;
  top: 8px;
  right: 80px;
  opacity: 0.85;
  font-size: 134%;
`;

export const SearchResultsSection = styled.ul<{ isMobileDevice: boolean }>`
  border: 1px solid ${theme.palette.toolTipBackground};
  color: ${theme.palette.wetAsphalt};
  border-radius: 0 !important;

  li {
    position: relative;

    &:hover:not(.empty) {
      cursor: pointer;
      background: ${theme.palette.lightPurpleTwo};
      .bps {
        background: ${theme.palette.white};
      }
    }
  }
  span.absolute {
    position: absolute !important;
    right: 0;
  }

  position: absolute;
  cursor: default;
  left: 0px;
  background: ${theme.palette.white};
  overflow-y: scroll;
  height: auto;
  z-index: 1001;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  list-style: none;
  padding: 0;
  margin: 0;
  display: block;
  outline: none;
  width: -webkit-fill-available;

  li.single-notification {
    display: table;
    height: 100%;
    min-height: 69px;

    .deal-type-sticker {
      position: absolute;
      top: 12px;
      right: 60px;
      opacity: 0.85;
    }

    .ford-ici-sticker {
      position: absolute;
      top: 34px;
      right: 59px;
    }

    background-color: ${theme.palette.white};
    border-bottom: 1px solid ${theme.palette.backgroundGray};
    padding: 0 10px;
    float: left;
    width: 100%;
    padding-left: 0;
    &:hover:not(.empty),
    &:focus,
    &:active,
    &.active {
      background-color: ${theme.palette.lightPurpleFive};
    }
    &.empty {
      cursor: default;
    }
    > span {
      content: '\f00d';
      font-size: ${theme.typography.h6}px;
      color: ${theme.palette.basicGrayThree};
      font-family: FontAwesome;
      position: relative;
      left: 45px;
      top: 4px;
      &:hover {
        color: ${theme.palette.basicGrayFour};
        cursor: pointer;
      }
    }
    .left {
      margin-right: 10px;
      margin-top: 10px;
      width: 38px;
      float: left;
      p {
        color: ${theme.palette.purpleSeven};
        font-size: ${theme.typography.fontSize20}px;
        font-weight: ${theme.typography.fontWeights.bold};
        padding-top: 3px;
        text-align: center;
        width: 100%;
        line-height: 18px;
        strong {
          color: ${theme.palette.darkGrayFour};
          font-size: ${theme.typography.fontSize}px;
          font-weight: ${theme.typography.fontWeights.medium};
          margin-left: 6px;
          span {
            color: ${theme.palette.dusty};
            vertical-align: top;
            font-size: 80%;
          }
        }
      }
    }
  }
  }

  ${(props) =>
    props.isMobileDevice
      ? `

    max-height: calc(100vh - 118px);
    width: 100vw;
    top: 56px;
        `
      : `
        top: 30px;
        max-height: 87vh;
        min-height: 61px;
      `}
`;

export const DealInfo = styled.div`
  border-left: 0;
  width: 65%;
  display: table-cell;
  vertical-align: middle;
  float: none;
  padding-bottom: 7px;
  padding-top: 7px;

  .customer {
    color: ${theme.palette.basicGray};
    font-weight: ${theme.typography.fontWeights.semibold};
    line-height: 1.1;
    margin-bottom: 5px;
    word-break: break-all;
  }

  padding-left: 11px;

  p {
    line-height: 1.3;
    margin-bottom: 0;
    width: 100%;
    float: left;
  }
  p + p {
    padding-bottom: 5px;

    &:last-of-type {
      padding-bottom: 0;
    }
  }

  .am-icon-warning {
    color: ${theme.palette.warningTwo};
    font-size: 15px;
    position: absolute;
    left: 0;
    top: -2px;
  }
`;

export const Meta = styled.div`
  padding-top: 30px;
  width: 26px;
  float: right;
`;

export const StyledSpan = styled.span`
  color: #428bca !important;
  cursor: pointer;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;
export const YearTrim = styled.p`
  clear: both;
  width: 100%;
  color: ${theme.palette.dusty};
  font-size: ${theme.typography.h6}px;
  font-weight: ${theme.typography.fontWeights.medium};
`;
